import request from '@/utils/request'
import Vue from 'vue'

export function adminLogin (username, password) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: '/admin-user/login',
    method: 'post',
    data: {
      login: username,
      password: password
    }
  })
}

export function getCustomer (data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/customers`,
    method: 'get',
    params: {
      token: data.token,
      userId: data.userid
    }
  })
}

export function getLogos (data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/logos`,
    method: 'get',
    params: {
      token: data.token,
      userId: data.userid
    }
  })
}

export function addCustomer (token, adminuserid, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/customers?token=${token}&userId=${adminuserid}`,
    method: 'post',
    data: {
      name: data.name,
      shortName: data.shortName,
      logoId: data.logoId,
      prefix_login: data.prefix_login,
      domain: data.domain,
      url: data.url,
      regionLevel: data.regionLevel
    }
  })
}

export function editCustomer (customerid, token, adminuserid, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/customers/${customerid}?token=${token}&userId=${adminuserid}`,
    method: 'patch',
    data: {
      name: data.name,
      shortName: data.shortName,
      logoId: data.logoId,
      prefix_login: data.prefix_login,
      domain: data.domain,
      url: data.url,
      regionLevel: data.regionLevel
    }
  })
}

export function resetPwd (userid, token, adminuserid) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/customers/reset/${userid}?token=${token}&userId=${adminuserid}`,
    method: 'patch'
  })
}

export function addCommodityCode (token, adminuserid, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/admin/commoditycode?token=${token}&userId=${adminuserid}`,
    method: 'post',
    data: {
      code: data.code,
      name: data.name,
      shortName: data.shortName,
      sinopeccode: data.sinopeccode,
      effective: data.effective,
      remark: data.remark,
      oilattribute: data.oilattribute
    }
  })
}

export function getCommodityCode (token, adminuserid, skip, take) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/admin/commoditycode`,
    method: 'get',
    params: {
      token: token,
      userId: adminuserid,
      skip: skip,
      take: take
    }
  })
}

export function editCommodityCode (token, adminuserid, id, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/admin/commoditycode/${id}?token=${token}&userId=${adminuserid}`,
    method: 'patch',
    data: {
      code: data.code,
      name: data.name,
      shortName: data.shortName,
      sinopeccode: data.sinopeccode,
      effective: data.effective,
      remark: data.remark,
      oilattribute: data.oilattribute
    }
  })
}

export function deleteCommodityCode (token, adminuserid, id) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/admin/commoditycode/${id}?token=${token}&userId=${adminuserid}`,
    method: 'delete'
  })
}

export function getCommodityCodeByUser (skip, take) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/commoditycode`,
    method: 'get',
    params: {
      skip: skip,
      take: take
    }
  })
}

export function getTank (customerId, gasStationId) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/tank/${customerId}/${gasStationId}/list`,
    method: 'get'
  })
}

export function addTank (customerId, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/tank/${customerId}`,
    method: 'post',
    data: {
      gasStationId: data.gasStationId,
      tankId: data.tankId,
      commodityCode: data.commodityCode,
      safetyHieght: data.safetyHieght,
      tankHeight: data.tankHeight,
      alarmHeight: data.alarmHeight,
      effective: data.effective
    }
  })
}

export function editTank (customerId, id, data) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/tank/${customerId}/${id}`,
    method: 'patch',
    data: {
      gasStationId: data.gasStationId,
      tankId: data.tankId,
      commodityCode: data.commodityCode,
      safetyHieght: data.safetyHieght,
      tankHeight: data.tankHeight,
      alarmHeight: data.alarmHeight,
      effective: data.effective
    }
  })
}

export function deleteTank (customerId, id) {
  return request({
    baseURL: Vue.prototype.BASE_URL,
    url: `/tank/${customerId}/${id}`,
    method: 'delete'
  })
}



// WEBPACK FOOTER //
// ./src/api/adminuser.js